import React, { useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../../components/ui/table";
import Checkbox from "../../../../components/form/input/Checkbox";

// Interface for the table row data
interface TableRowData {
  id: string;
  Suppliername: string;
  price: string; // Price of the product
}

const initialTableRowData: TableRowData[] = [
  {
    id: "Du121",
    Suppliername: "Abe & Gizelle Patisserie",
    price: "134",
  },
  {
    id: "43214",
    Suppliername: "AYVA Packaging Pty Ltd",
    price: "189",
  },
  {
    id: "D61",
    Suppliername: "Advanced Poultry",
    price: "14",
  },
  {
    id: "lE1",
    Suppliername: "Allie's Cold Pressed Juice",
    price: "154",
  },
  {
    id: "a43212",
    Suppliername: "Amazonia Specialties Pty Ltd",
    price: "134",
  },
];

export default function SupplierCosts() {
  const [tableRowData, setTableRowData] = useState<TableRowData[]>(
    initialTableRowData
  );
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelectedRows(tableRowData.map((row) => row.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id: string) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((rowId) => rowId !== id)
        : [...prevSelected, id]
    );
  };

  const handlePriceChange = (id: string, newPrice: string) => {
    setTableRowData((prevData) =>
      prevData.map((row) =>
        row.id === id ? { ...row, price: newPrice } : row
      )
    );
  };

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white pt-4 dark:border-white/[0.05] dark:bg-white/[0.03]">
      <div className="flex flex-col gap-4 px-6 mb-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-base font-semibold text-gray-800 dark:text-white/90">
            Select Supplier to Enter Prices
          </p>
        </div>
      </div>

      <div className="max-w-full overflow-x-auto">
        <div className="min-w-[617px] 2xl:min-w-[808px]">
          <Table>
            <TableHeader className="px-6 py-3.5 border-t border-gray-100 border-y bg-gray-50 dark:border-white/[0.05] dark:bg-gray-900">
              <TableRow>
                <TableCell className="px-6 py-3 font-medium text-gray-700 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
                  <div className="flex items-center gap-3">
                    <div>
                      <span className="font-medium text-gray-700 text-theme-xs dark:text-gray-400">
                        Supplier
                      </span>
                    </div>
                  </div>
                </TableCell>

                <TableCell className="px-6 py-3 font-medium text-gray-700 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
                  Code
                </TableCell>
                <TableCell className="px-6 py-3 font-medium text-gray-700 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
                  Block Supplier
                </TableCell>
                <TableCell className="px-6 py-3 font-medium text-gray-700 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
                  Price
                </TableCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tableRowData.map((row: TableRowData) => (
                <TableRow key={row.id}>
                  <TableCell className="px-4 sm:px-6 py-3.5">
                    <div className="flex items-center gap-3">
                      <div>
                        <Checkbox
                          checked={selectedRows.includes(row.id)}
                          onChange={() => handleRowSelect(row.id)}
                        />
                      </div>
                      <div>
                        <span className="text-gray-500 text-theme-sm dark:text-gray-400">
                          {row.Suppliername}
                        </span>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="px-4 sm:px-6 py-3.5">
                    <div className="flex items-center gap-3">
											<input
												type="text"
												value={row.id}
												className="text-gray-500 text-theme-sm dark:text-gray-400 border rounded"
                    	/>
                    </div>
                  </TableCell>
                  <TableCell className="px-4 sm:px-6 py-3.5">
                    <p className="text-gray-500 text-theme-sm dark:text-gray-400">
                      <div>
                        <Checkbox
                          checked={selectedRows.includes(row.id)}
                          onChange={() => handleRowSelect(row.id)}
                        />
                      </div>
                    </p>
                  </TableCell>
                  <TableCell className="px-4 sm:px-6 py-3.5">
                    <input
                      type="number"
                      value={row.price}
                      className="text-gray-500 text-theme-sm dark:text-gray-400 border rounded"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}